import './FilterEditorTemplate.less';
import React from 'react';
import operatorLabels from "../../config/operatorLabels";
import {translate} from "../../../../i18n";


export function FilterEditorTemplate({
    fieldName,
    operator,
    setOperator = null,
    availableOperators = null,
    inputComponent,
    error,
    apply
}) {

    return <div className="filter-editor-template">
        <div className="field">
            {fieldName}
        </div>
        <div className="operator">
            {
                (availableOperators === null || setOperator === null)
                    ? <span dangerouslySetInnerHTML={{__html: operatorLabels[operator]}}/>
                    : <select
                        defaultValue={operator}
                        onChange={(event) => setOperator(event.target.value)}
                    >
                        {
                            availableOperators.map(operator => {
                                const html = operatorLabels[operator];
                                return (
                                    <option
                                        key={operator}
                                        value={operator}
                                        dangerouslySetInnerHTML={{__html: html}}
                                    />
                                );
                            })
                        }
                    </select>
            }
        </div>
        <div className="value">
            {inputComponent}
        </div>
        {
            error !== null &&
            <div className="error">
                {error}
            </div>
        }
        {
            error === null &&
            <button
                type="button"
                className="apply-button"
                onClick={() => apply()}
            >
                {translate('Apply')}
            </button>
        }
    </div>;
}
